import { useOnMount } from '@hooks';
import { useState } from 'react';
export const DeferredRender = ({ children, delay }) => {
    const [isReady, setIsReady] = useState(false);
    useOnMount(() => {
        setTimeout(() => setIsReady(true), delay);
    });
    return isReady ? children : null;
};
